// crewbit-admin/src/components/money/bootstrap/BootstrapReasoningPanel.tsx
//
// Tier 2-UI Phase A §WorldClass.4 — 4-row reasoning display per Decision §A.D6.
// Mirror of mobile BootstrapReasoningPanel. Web idiom: inline CSS + lucide-react.
//
// `tips_enabled_default` intentionally NOT surfaced in v1 (RPC body doesn't
// persist it to business_financial_settings). Filed as queued
// §WorldClass.5.BootstrapTipsPersistence.

import { Lightbulb } from 'lucide-react';
import { palette, radii, spacing } from '../../../styles/tokens';
import type { BootstrapDefaultsDerived } from '../../../types/onboarding';

interface Props {
  derived: BootstrapDefaultsDerived;
}

export default function BootstrapReasoningPanel({ derived }: Props) {
  const { reasoning } = derived;

  const rows: { label: string; value: string }[] = [
    { label: 'Tax rate', value: reasoning.hst_source },
    { label: 'Trade', value: reasoning.trade_source },
    { label: 'Mileage', value: `Using ${reasoning.mileage_year} CRA rates` },
    {
      label: 'Region',
      value: reasoning.region_class === 'province' ? 'Province' : 'Territory',
    },
  ];

  return (
    <div
      style={{
        background: palette.accentWash,
        borderRadius: radii.md,
        padding: spacing.md,
        display: 'flex',
        flexDirection: 'column',
        gap: spacing.sm,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing.xs,
          color: palette.accent,
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: 0.4,
          textTransform: 'uppercase',
        }}
      >
        <Lightbulb size={14} />
        How we picked these
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: spacing.xs }}>
        {rows.map((row) => (
          <div
            key={row.label}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: spacing.sm,
            }}
          >
            <div style={{ fontSize: 12, color: palette.g600 }}>{row.label}</div>
            <div
              style={{
                fontSize: 12,
                color: palette.g800,
                fontWeight: 500,
                textAlign: 'right',
              }}
            >
              {row.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
